/**
 * Constants for property names used in change order properties
 * These should match the property names used in the backend
 */

// Impact Details Properties
export const COST_IMPACT_PROPERTY = 'COST_IMPACT';
export const WORK_PERFORMED_PROPERTY = 'WORK_PERFORMED';
export const OSD_IMPACT_PROPERTY = 'OSD_IMPACT';
export const EXPECTED_DELIVERY_DATE_PROPERTY = 'EXPECTED_DELIVERY_DATE';
export const OSD_IMPACT_COMMENT_PROPERTY = 'OSD_IMPACT_COMMENT';

// GCM Property
export const GCM_PROPERTY = 'GCM';
